<div class="main">
  <section class="about">
    <div class="about-container">
      <div class="about-image">
        <img src="assets/images/Sachacabrona.jpeg" alt="Bora Logo" />
      </div>

      <div class="about-content">
        <h2>Sobre nosotros</h2>

        <p>
          Arrancamos hace algunos años, casi de forma improvisada, con la idea
          simple de ofrecer una hamburguesa distinta. Con el tiempo fuimos
          creciendo, mejorando recetas, sumando sabores, escuchando a cada
          persona que pasó por nuestra mesa.
        </p>

        <p>
          Hoy contamos con nuestro local ubicado en
          <strong>Savio</strong>, donde seguimos manteniendo la misma esencia de
          siempre: productos frescos, cocción artesanal y la búsqueda constante
          del sabor perfecto.
        </p>

        <p>
          Cada día encendemos la plancha con el mismo entusiasmo del primer día,
          porque creemos que una buena hamburguesa no es solo comida… es
          experiencia, momento y placer.
        </p>
      </div>
    </div>
  </section>
</div>
